import React from 'react'
import { log } from 'common-tools/index'
import { Grid, GridContainer, GridCell } from 'common-controls/Core/index'
import { LayoutContainer } from 'common-controls/App/index'
import { Router } from 'common-tools/ReachRouter'

export class SiteRouter extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      hasError: false,
      error: null,
      info: null
    }
  }

  componentDidCatch (error, info) {
    log.Error('Route Error', { Error: error, Info: info })
    this.setState({
      hasError: true,
      error: error,
      info: info
    })
  }

  renderError () {
    const { error, info } = this.state
    return <LayoutContainer>
      <GridContainer full>
        <Grid marginX>
          <GridCell smallOffSet={3} />
          <GridCell small={6}>
            <h3>Error</h3>
            <p><b>Message</b></p>
            <p>{error.message}</p>
            <p><b>Stack Trace</b></p>
            <p>{error.stack}</p>
            <p><b>Component Trace</b></p>
            <p>{info.componentStack}</p>
          </GridCell>
        </Grid>
      </GridContainer>
    </LayoutContainer>
  }

  render () {
    const { children, className } = this.props
    const { hasError } = this.state

    if (hasError) {
      return this.renderError()
    }

    return <Router className={className}>{children}</Router>
  }
}
